export const title = 'Users';
export const description =
  'Users with the "Facebook Page Collaborator" or "LiveChat Agent" role can be granted' +
  ' or revoked access to each Facebook Page in your Account.' +
  ' Users with permission below will be granted access to bots, contacts,' +
  ' and other data associated with this page in Customers.ai or only to Inbox depending on the role.';
